import { render, staticRenderFns } from "./section-testimonials.vue?vue&type=template&id=3e5796f6&scoped=true&"
import script from "./section-testimonials.vue?vue&type=script&lang=js&"
export * from "./section-testimonials.vue?vue&type=script&lang=js&"
import style0 from "./section-testimonials.vue?vue&type=style&index=0&id=3e5796f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5796f6",
  null
  
)

export default component.exports